import { useCallback, useState } from 'react';
import { readStore, writeStore } from '../../../shared/lib/localStore';

// Integración main→dev, epic C2: estado persistido de la vista de LISTA agrupada por etapa
// (`collapsedStages` + toggle "ocultar completadas"). Extraído de `ComponentTaskHoy.jsx` para
// no inflar el contenedor (ya está en su cap justificado).
export function useTaskListGrouping() {
    const [collapsedStages, setCollapsedStages] = useState(
        () => readStore('tasks_collapsed_stages', { fallback: {} }),
    );
    const [showCompletedTasks, setShowCompletedTasks] = useState(
        () => readStore('tasks_show_completed', { fallback: true }),
    );
    const [showSubtasksAsNested, setShowSubtasksAsNested] = useState(
        () => readStore('tasks_show_subtasks_nested', { fallback: true }),
    );

    const onToggleStage = useCallback((stage) => {
        setCollapsedStages((prev) => {
            const next = { ...prev, [stage]: !prev[stage] };
            writeStore('tasks_collapsed_stages', next);
            return next;
        });
    }, []);

    const onToggleShowCompleted = useCallback(() => {
        setShowCompletedTasks((prev) => {
            writeStore('tasks_show_completed', !prev);
            return !prev;
        });
    }, []);

    const onToggleShowSubtasksAsNested = useCallback(() => {
        setShowSubtasksAsNested((prev) => {
            writeStore('tasks_show_subtasks_nested', !prev);
            return !prev;
        });
    }, []);

    // Nombres alineados con los props de `TaskListView` y con los params que lee
    // `useTaskPipeline` — el contenedor pasa el objeto entero con spread a ambos.
    return { collapsedStages, showCompletedTasks, showSubtasksAsNested, onToggleStage, onToggleShowCompleted, onToggleShowSubtasksAsNested };
}
